<!------------ bare de chargement ----------------->
<div *ngIf="exist; else attente"></div>

<ng-template #attente>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div class="p-10">
  <button (click)="goToCaisse()" mat-stroked-button style="margin-right: 10px">
    <mat-icon>undo</mat-icon>
    Retour au caisse
  </button>
</div>
<mat-divider></mat-divider>
<form #f="ngForm">
  <div class="content display-flex-2">
    <div class="display-flex">
      <mat-card>
        <div class="entet-recherche">
          <span>Période</span>
        </div>
        <mat-form-field style="width: 130px" appearance="outline">
          <mat-label>Du</mat-label>
          <input
            required
            name="dateDebut"
            [(ngModel)]="dateDebut"
            #date_Debut="ngModel"
            placeholder="Du"
            [matDatepicker]="picker1"
            matInput
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
        <br />
        <mat-form-field style="width: 130px" appearance="outline">
          <mat-label>Au</mat-label>
          <input
            required
            name="dateFin"
            [(ngModel)]="dateFin"
            #date_Fin="ngModel"
            placeholder="Au"
            [matDatepicker]="picker2"
            matInput
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
      </mat-card>
      <mat-card>
        <div class="display-flex-2 entet-recherche">
          <span>{{ listeTicket.length }} Ticket(s)</span>
          <span>{{ totalTicket }} DT</span>
        </div>
        <mat-form-field style="width: 150px" appearance="outline">
          <mat-label>N° Ticket debut</mat-label>
          <input
            name="numTicketDebut"
            [(ngModel)]="numTicketDebut"
            #numTicket_Debut="ngModel"
            placeholder="N° Ticket"
            matInput
          />
          <button
            mat-button
            matSuffix
            mat-icon-button
            (click)="clearNumTicketDebut()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <br />
        <mat-form-field style="width: 150px" appearance="outline">
          <mat-label>N° Ticket fin</mat-label>
          <input
            disabled
            name="numTicketFin"
            [(ngModel)]="numTicketFin"
            #num_TicketFin="ngModel"
            placeholder="N° Ticket"
            matInput
          />
          <button
            disabled
            mat-button
            matSuffix
            mat-icon-button
            (click)="clearNumTicketFin()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </mat-card>
      <mat-card>
        <div class="display-flex-2 entet-recherche">
          <span>
            <!-- {{selectedArticle.nbrArticle}} -->
            Article & Client
          </span>
          <!-- <span>{{selectedArticle.total}} DT</span> -->
        </div>
        <!-- <mat-form-field  style="width: 300px;"   appearance="outline" >
                    <mat-label>Recherche articles</mat-label>
                    <input disabled="true" name="article" [(ngModel)]="selectedArticle.Art_Des" #article="ngModel"  matInput>
                    <button mat-button matSuffix mat-icon-button (click)="openFrmRecherche(frmListe,'article')">
                        <mat-icon>search</mat-icon>
                    </button>
                    <button mat-button matSuffix mat-icon-button (click)="clearSelectedArticle()">
                        <mat-icon>clear</mat-icon>
                    </button>
                </mat-form-field> -->

        <app-recherche
          #article
          [api]="generalService.api"
          [numColonneToShow]="4"
          [numColonneToReturn]="0"
          recherche="article"
          (ChampEnter)="selectionChange($event)"
          placeholder="Recherche articles"
        >
        </app-recherche>
        <br />
        <app-recherche
          #client
          [api]="generalService.api"
          [numColonneToShow]="1"
          (ChampEnter)="selectionClientChange($event)"
          recherche="TierType"
          [param]="'1'"
          name="Machine_Emp"
          placeholder="Recherche client"
        >
        </app-recherche>
        <!-- <mat-form-field  style="width: 300px;"   appearance="outline" >
                    <mat-label>Recherche Clients</mat-label>
                    <input disabled="true" name="clients" [(ngModel)]="selectedClient.Tiers_RS" #clients="ngModel"  matInput>
                    <button mat-button matSuffix mat-icon-button (click)="openFrmRecherche(frmListe,'client')">
                        <mat-icon>search</mat-icon>
                    </button>
                    <button mat-button matSuffix mat-icon-button (click)="clearSelectedClient()">
                        <mat-icon>clear</mat-icon>
                    </button>
                </mat-form-field> -->
      </mat-card>

      <mat-card>
        <div class="display-flex-2 entet-recherche">
          <span>Etablissement & Caisse</span>
        </div>
        <mat-form-field appearance="outline" style="width: 200px">
          <mat-label>Etablissement</mat-label>
          <mat-select
            name="etablissement"
            [(ngModel)]="selectedEtablissement"
            #etablissementt="ngModel"
          >
            <mat-option value="-1">Tous</mat-option>
            <mat-option
              *ngFor="let etablissement of listeEtablissement"
              [value]="etablissement"
            >
              {{ etablissement }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <br />
        <mat-form-field appearance="outline" style="width: 200px">
          <mat-label>Caisse</mat-label>
          <mat-select
            name="caisse"
            [(ngModel)]="selectedCaisse.Cash_Code"
            #caissee="ngModel"
          >
            <mat-option value="-1">Tous</mat-option>
            <mat-option
              *ngFor="let caisson of listeCaisse"
              [value]="caisson.Cash_Code"
            >
              {{ caisson.Cash_Code }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </mat-card>
      <mat-card>
        <div class="display-flex-2 entet-recherche">
          <span>Caissié</span>
        </div>

        <mat-form-field appearance="outline" style="width: 200px">
          <mat-label>Caissié</mat-label>
          <mat-select
            name="caisson"
            [(ngModel)]="selectedCaisson.Perso_Matricule"
            #caissonn="ngModel"
          >
            <mat-option value="-1">Tous</mat-option>
            <mat-option
              *ngFor="let caisson of listeCaisson"
              [value]="caisson.Perso_Matricule"
            >
              {{ caisson.Perso_Nom }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </mat-card>
    </div>
    <div>
      <button
        [disabled]="!exist"
        mat-stroked-button
        class="colorGreen"
        (click)="recherche()"
      >
        <mat-icon>search</mat-icon>
        Rechercher
      </button>
    </div>
  </div>
</form>

<mat-divider></mat-divider>
<div class="content">
  <div class="display-flex-3">
    <div>
      <div>
        <app-liste
          #listeTicketsComponent
          [showSort]="true"
          [showFilter]="true"
          [width]="1300"
          [dataSource]="listeTicketBrut"
          [positionScrol]="'rtl'"
          [columns]="columnsTicket"
          [customFooter]="customFooter"
          (output)="output($event)"
        >
        </app-liste>
      </div>
    </div>

    <div class="card" *ngIf="dsDocCash">
      <div class="display-flex-2 card-heat">
        <span>{{ dsDocCash.DocCash[0].Doc_Date }}</span>
        <span>{{ dsDocCash.DocCash[0].Doc_RS }}</span>
        <span>{{ dsDocCash.DocCash[0].Doc_TTTC }} DT</span>
      </div>

      <div class="content">
        <div *ngFor="let article of dsDocCash.DocCashD">
          <div class="display-flex">
            <img
              class="avatar"
              onerror="this.src='/assets/1.jpg'"
              [src]="imageDomain + article.Art_Code + '.jpg'"
            />
            <div style="width: 20px">{{ article.Sto_Q }}</div>
            <div style="width: 200px">{{ article.Art_Des }}</div>
            <div style="width: 40px">{{ article.DocCashD_PTTC }}</div>
            <div *ngIf="article.DocCashD_Rem">{{ article.DocCashD_Rem }}</div>
          </div>
        </div>
        <hr />
        <!-- <b>Reglement</b>
        <div *ngFor="let reglement of dsDocCash.DocCashR">
          <div class="display-flex">
            <div style="width: 30px">{{ reglement.DocCashR_Montant }}</div>
            <div style="width: 50px">
              {{ getCashRByIndex(reglement.DocCashR_Type) }}
            </div>
            <div style="width: 70px">{{ reglement.Doc_Ref }}</div>
            <div style="width: 70px">{{ reglement.Doc_Banque }}</div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>
<ng-template #frmListe>
  <app-liste
    #listeConmponent
    [titre]="titreFrmRecherche"
    [listBtn]="listBtn"
    [showFilter]="true"
    [showSort]="true"
    [dataSource]="liste"
    [columns]="columns"
    (output)="outputArticle($event)"
  >
  </app-liste>
</ng-template>
<ng-template #frmStatistique>
  <button
    mat-stroked-button
    class="text-white bg-red-500 float-right"
    (click)="close()"
  >
    Fermer
  </button>
  <div class="flex justify-between items-center">
    <div class="flex flex-col w-10/12">
      <div class="display-flex-2">
        <h3><b>Caisse:</b> {{ listeTicketsComponent.row.Cash_Code }}</h3>
        <h3><b>Numéro Clôture:</b> {{ listeTicketsComponent.row.CashD_Id }}</h3>
      </div>
      <app-liste
        #statistiqueConmponent
        [showFilter]="false"
        [showSort]="false"
        [dataSource]="listeStatistique"
        [columns]="columnsStatistique"
        [customFooter]="customFooterStatistique"
      >
      </app-liste>
    </div>
    <div class="flex flex-col ml-5">
      <div class="diagram">
        <canvas #myCanvas width="100" height="100"></canvas>
      </div>
      <div class="diagram">
        <canvas #myCanvas2 width="100" height="100"></canvas>
      </div>
    </div>
  </div>
</ng-template>
